<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="4" class="order-xl-2">
          <b-card
            no-body
            class="card-profile"
            img-src="img/theme/img-1-1000x600.jpg"
            alt="Image placeholder"
            img-top
          >
            <b-row class="justify-content-center">
              <b-col lg="3" class="order-lg-2">
                <!-- <div class="card-profile-image">
          <a href="#">
            <b-img src="img/theme/team-4.jpg" rounded="circle" />
          </a>
        </div> -->
              </b-col>
            </b-row>

            <b-card-header
              class="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
              <!-- <div class="d-flex justify-content-between">
        <a href="#" class="btn btn-sm btn-info mr-4">Connect</a>
        <a href="#" class="btn btn-sm btn-default float-right">Message</a>
      </div> -->
            </b-card-header>

            <b-card-body class="pt-0">
              <b-row> </b-row>
              <div class="text-center">
                <h5 class="h3">
                  {{ user.firstName }} {{ user.lastName
                  }}<span class="font-weight-light"
                    >, {{ user.dob | getAge }}</span
                  >
                </h5>
                <div class="h5 font-weight-300">
                  <i class="ni location_pin mr-2"></i>|
                  <span v-for="(role, index) in user.role" :key="index"
                    >{{ role | capitalizeAll }} |
                  </span>
                </div>
                <div class="h5 mt-4">
                  <i class="ni business_briefcase-24 mr-2"></i>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col xl="8" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Edit User</h3>
              </b-col>
              <b-col cols="4" class="text-right">
                <base-button
                  v-if="user && !user.isApproved"
                  type="primary"
                  size="sm"
                  @click="changeApproval('isApproved')"
                  ><i class="ni ni-like-2"></i> Approve and
                  Activate</base-button
                >
                <base-button
                  v-if="user && user.isApproved && user.isActive"
                  type="danger"
                  size="sm"
                  @click="changeApproval('isActive')"
                  ><i class="ni ni-fat-remove"></i> Deactivate</base-button
                >
                <base-button
                  v-if="user && user.isApproved && !user.isActive"
                  type="success"
                  size="sm"
                  @click="changeApproval('isActive')"
                  ><i class="ni ni-like-2"></i> Activate</base-button
                >
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <h6 class="heading-small text-muted mb-4">User information</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Username"
                      placeholder="Username"
                      :value="user.email"
                      :disabled="true"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="Email address"
                      placeholder="mike@email.com"
                      :value="user.email"
                      :disabled="true"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="First Name"
                      placeholder="First Name"
                      :value="user.firstName"
                      :disabled="true"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      :value="user.lastName"
                     :disabled="true"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="date"
                      label="Date Of Birth"
                      placeholder="Date Of Birth"
                      :value="dateOfBirth"
                      :disabled="true"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Gender"
                      placeholder="Male"
                      :value="user.gender"
                      :disabled="true"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4" />

              <!-- Address -->
              <h6 class="heading-small text-muted mb-4">Information</h6>

              <div v-if="user && user.isApproved" class="pl-lg-4">
                <b-row>
                  <b-col md="12">
                    <base-input
                      label="Airline"
                      placeholder="Airlines"
                    >
                    <select v-model="user.airline"  class="form-control">
                      <option v-for="al in indianAirlines" :key="al.call_sign" :value ="al.call_sign">{{al.name}}</option>
                    </select>
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      label="Post"
                      placeholder="Post"
                    >
                     <select v-model="user.post"  class="form-control">
                      <option v-for="al in posts" :key="al.key" :value ="al.key">{{al.name}}</option>
                    </select>
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      label="Designation"
                      placeholder="Designation"
                    >
                     <select v-model="user.pilot_designation"  class="form-control">
                      <option v-for="al in designations" :key="al.key" :value ="al.key">{{al.name}}</option>
                    </select>
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      label="Region"
                      placeholder="Region"
                    >
                     <select v-model="user.region"  class="form-control">
                      <option v-for="al in regions" :key="al.key" :value ="al.key">{{al.label}}</option>
                    </select>
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Phone"
                      placeholder="Phone"
                      :value="user.mobile"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <!-- <hr class="my-4" />

      <h6 class="heading-small text-muted mb-4">About me</h6>
      <div class="pl-lg-4">
        <b-form-group
          label="About Me"
          label-class="form-control-label"
          class="mb-0"
          label-for="about-form-textaria"
        >
          <b-form-textarea
            rows="4"
            value="A beautiful premium dashboard for BootstrapVue."
            id="about-form-textaria"
            placeholder="A few words about you ..."
          ></b-form-textarea>
        </b-form-group>
      </div> -->
      <b-row class="form-group">
                  <b-col md="12" class="text-right">
                    <base-button icon type="success" @click="updateUser">
                      <span class="btn-inner--icon"
                        ><i class="ni ni-bag-17"></i
                      ></span>
                      <span class="btn-inner--text">Update</span>
                    </base-button>
                  </b-col>
                </b-row>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
// import ProgressTrackList from "@/views/Dashboard/ProgressTrackList";
import swal from "sweetalert2";
import {indianAirlines,posts,designations,checkboxes} from "../../constants/const.js"
import { getAge, capitalizeAll } from "../../util/filters";
import { mapActions, mapGetters } from "vuex";
import { API } from "../../services/api.service";
import moment from "moment";
export default {
  //   components: {
  //     EditProfileForm,
  //     UserCard,
  //     // ProgressTrackList
  //   },

  data() {
    return {
      regions:checkboxes,
      indianAirlines,
      designations,
      posts,
      user: {}
    };
  },
  filters: { getAge, capitalizeAll },
  computed: {
    dateOfBirth: {
      get() {
        return this.user.dob ? moment(this.user.dob).format("yyyy-MM-DD") : "";
      },
      // setter
      set(newValue) {
        this.user.dob = new Date(newValue);
      }
    }
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      API.GET_USER(this.$route.params.id)
        .then((res, err) => {
          try {
            if (res) {
              if (res.data.ok) {
                if (res.data.result) {
                  this.user = res.data.result;
                }
              }
            }
          } catch (e) {
            swal.fire({
              title: `${e}`,
              buttonsStyling: false,
              type: "warning",
              confirmButtonClass: "btn btn-danger btn-fill"
            });
          }
        })
        .catch(err => {
          swal.fire({
            title: `${err.response.data.message}`,
            buttonsStyling: false,
            type: "warning",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
          this.$router.push(`/members`);
        });
    },
    changeApproval(key) {
      var obj = {};
      if (key === "isApproved" && !this.user.isApproved) {
        obj["isApproved"] = true;
        obj["isActive"] = true;
      } else obj[key] = !this.user[key];
      this.updateUser(obj);
    },
    updateUser() {
      let dataObj = this.user;
      API.UPDATE_USER(this.$route.params.id, dataObj)
        .then(res => {
          if (res.data.ok) {
            swal.fire({
              title: `User details updated!`,
              buttonsStyling: false,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill"
            });
            this.getUser();
          }
        })
        .catch(e => {
          var a = this.users;
          a.findIndex(x => x.userId === uid);

          swal.fire({
            title: `${e.response.data.message}` || "Something went Wrong!",
            buttonsStyling: false,
            type: "error",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    ...mapActions("user", ["setUserInfo", "setJWTToken"])
  }
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
